import { a as parseHeaders } from "./helpers.js";
const global = (() => {
  try {
    return window || {};
  } catch (e) {
    return {};
  }
})();
function fallback(obj, key, value) {
  if (!(key in obj)) {
    obj[key] = value;
  }
}
fallback(global, "fetch", (resource, init) => new Promise((resolve, reject) => {
  if (!global.XMLHttpRequest) {
    return reject({
      name: "NotSupportedError",
      message: "Not support XMLHttpRequest."
    });
  }
  const xhr = new XMLHttpRequest();
  xhr.onerror = reject;
  xhr.onreadystatechange = () => {
    if (xhr.readyState !== 4) {
      return;
    }
    resolve({
      ok: xhr.status >= 200 && xhr.status <= 299,
      url: xhr.responseURL || resource,
      type: (init == null ? void 0 : init.mode) || "basic",
      status: xhr.status,
      headers: parseHeaders(xhr.getAllResponseHeaders()),
      statusText: xhr.statusText,
      redirected: xhr.responseURL && xhr.responseURL !== resource,
      json: () => JSON.parse(xhr.responseText)
    });
  };
  xhr.open((init == null ? void 0 : init.method) || "GET", resource, true);
  xhr.withCredentials = !!(init == null ? void 0 : init.credentials) && (init == null ? void 0 : init.credentials) !== "omit";
  const headers = (init == null ? void 0 : init.headers) || {};
  Object.keys(headers).forEach((key) => {
    xhr.setRequestHeader(key, headers[key]);
  });
  xhr.send(init == null ? void 0 : init.body);
}));
fallback(global, "WebSocket", class WebSocket {
  constructor() {
    const error = new Error("Not support WebSocket.");
    error.name = "NotSupportedError";
    throw error;
  }
  send() {
  }
  close() {
  }
});
fallback(global, "TextEncoder", class TextEncoder {
  encode(string) {
    const utf8Array = [];
    for (let i = 0; i < string.length; i++) {
      let charcode = string.charCodeAt(i);
      if (charcode < 128) {
        utf8Array.push(charcode);
      } else if (charcode < 2048) {
        utf8Array.push(192 | charcode >> 6, 128 | charcode & 63);
      } else if (charcode < 55296 || charcode >= 57344) {
        utf8Array.push(224 | charcode >> 12, 128 | charcode >> 6 & 63, 128 | charcode & 63);
      } else {
        const pair1 = (charcode & 1023) << 10;
        const pair2 = string.charCodeAt(++i) & 1023;
        charcode = 65536 + (pair1 | pair2);
        utf8Array.push(240 | charcode >> 18, 128 | charcode >> 12 & 63, 128 | charcode >> 6 & 63, 128 | charcode & 63);
      }
    }
    return new Uint8Array(utf8Array);
  }
});
fallback(global, "TextDecoder", class TextDecoder {
  decode(buffer) {
    const bufferView = new Uint8Array(buffer);
    const strings = [];
    for (let i = 0; i < bufferView.length; i++) {
      let charcode = bufferView[i];
      if (charcode < 128) {
        strings.push(String.fromCharCode(charcode));
      } else if (charcode < 224) {
        strings.push(String.fromCharCode(((31 & charcode) << 6) + (63 & bufferView[++i])));
      } else if (charcode < 240) {
        strings.push(String.fromCharCode(((15 & charcode) << 12) + ((63 & bufferView[++i]) << 6) + (63 & bufferView[++i])));
      } else {
        charcode = ((7 & charcode) << 18) + ((63 & bufferView[++i]) << 12) + ((63 & bufferView[++i]) << 6) + (63 & bufferView[++i]) - 65536;
        const pair1 = (charcode >> 10) + 55296;
        const pair2 = (charcode & 1023) + 56320;
        strings.push(String.fromCharCode(pair1, pair2));
      }
    }
    return strings.join("");
  }
});
var AppId;
(function(AppId2) {
  AppId2[AppId2["WEGAME"] = 10001] = "WEGAME";
})(AppId || (AppId = {}));
var ClientType;
(function(ClientType2) {
  ClientType2[ClientType2["WEGAME_ANDROID"] = 601] = "WEGAME_ANDROID";
  ClientType2[ClientType2["WEGAME_IOS"] = 602] = "WEGAME_IOS";
  ClientType2[ClientType2["WEGAME_H5"] = 603] = "WEGAME_H5";
  ClientType2[ClientType2["WEGAME_MP"] = 610] = "WEGAME_MP";
  ClientType2[ClientType2["WEGAME_ELECTRON"] = 611] = "WEGAME_ELECTRON";
  ClientType2[ClientType2["WEGAME_PC_CLIENT"] = 1e6] = "WEGAME_PC_CLIENT";
  ClientType2[ClientType2["WEGAME_PC_WEB"] = 1000005] = "WEGAME_PC_WEB";
  ClientType2[ClientType2["WEGAME_PC_INGAME"] = 1000515] = "WEGAME_PC_INGAME";
})(ClientType || (ClientType = {}));
const HOSTS = {
  pc: {
    dev: "dev.wegame.com.cn",
    test: "test.wegame.com.cn",
    pre: "qa.wegame.com.cn",
    prod: "www.wegame.com.cn"
  },
  h5: {
    dev: "tt-m.wegame.com.cn",
    test: "t-m.wegame.com.cn",
    pre: "pre-m.wegame.com.cn",
    prod: "m.wegame.com.cn"
  },
  act: {
    dev: "dev.tgp.qq.com",
    test: "dev.tgp.qq.com",
    pre: "demoact.wegame.com.cn",
    prod: "act.wegame.com.cn"
  },
  aov: {
    dev: "tt-aov.wegame.com.cn",
    test: "t-m-asia.arena-buddy.com",
    pre: "pre-m-asia.arena-buddy.com",
    prod: "aov.wegame.com.cn"
  },
  login: {
    dev: "testlogin.wegame.qq.com",
    test: "testlogin.wegame.qq.com",
    pre: "login.wegame.qq.com",
    prod: "login.wegame.qq.com"
  },
  report: {
    dev: "t-report.wegame.com.cn",
    test: "t-report.wegame.com.cn",
    pre: "report.wegame.com.cn",
    prod: "report.wegame.com.cn"
  }
};
function hostToEnv(host) {
  for (const hosts of Object.values(HOSTS)) {
    for (const env in hosts) {
      if (hosts[env] === host) {
        return env;
      }
    }
  }
  return "prod";
}
function envToHosts(env) {
  if (env === "dev") {
    env = "test";
  }
  const keys = Object.keys(HOSTS);
  return keys.reduce((hosts, key) => {
    hosts[key] = HOSTS[key][env];
    return hosts;
  }, {});
}
export { AppId as A, ClientType as C, envToHosts as e, fallback as f, global as g, hostToEnv as h };
